import React from 'react'
import styled, { keyframes } from 'styled-components'
import { withPrefix } from 'gatsby-link'

const logo = withPrefix('/images/p.svg')

const nameAnimation = keyframes`
  100% { background-position: 0 -384px; }
`

const nameAnimationMobile = keyframes`
  100% { background-position: 0 calc(-384px / 2); }
`

const Logo = styled.div`
  position: fixed;
  left: 50%;
  top: 50%;

  margin: 0;
  width: 768px;
  height: 128px;

  background: url(${logo}) no-repeat;
  background-size: cover;

  animation: ${nameAnimation} 0.52s steps(3) infinite;
  backface-visibility: hidden;
  perspective: 1000;

  transform: translate(-50%, -50%);

  @media (max-width: 700px) {
    width: calc(768px / 2);
    height: calc(128px / 2);

    animation: ${nameAnimationMobile} 0.52s steps(3) infinite;
  }
`

const Name = () => (
  <Logo title="Maxime Beaudoin" role="img" aria-label="Maxime Beaudoin" />
)

export default Name



// WEBPACK FOOTER //
// ./src/components/Name.js